function splashInit(){
    var forceSplash = window.location.href.indexOf("?splash") != -1;

    //show splash if not yet seen or if forced by querystring
    if(Cookies.get('splashSeen') != 'true' || forceSplash){
        document.getElementById("main").style.display = 'none';
        document.getElementById("splash").style.display = 'block';

        //go arrow
        document.querySelectorAll('.go-arrow-click').forEach(function(clicker) {
            clicker.addEventListener('click', function(e){
                //console.log('clicky click');
                e.preventDefault();
                startPuzzle();
            });
        });

        //skip-main
        document.querySelectorAll('#skip-main').forEach(function(clicker) {
            clicker.addEventListener('click', function(e){
                document.getElementById("main").style.display = 'block';
                document.getElementById("splash").remove();
            });
        });

        //escape key
        document.body.addEventListener('keydown', function(evt) {
            var isEscape = false;
            if ("key" in evt) {
                isEscape = (evt.key === "Escape" || evt.key === "Esc");
            } else {
                isEscape = (evt.keyCode === 27);
            }
            if (isEscape) {
                document.getElementById("main").style.display = 'block';
                document.getElementById("splash").remove(); //secret skip splash fast
            }
        });
        Cookies.set('splashSeen', 'true'); //cookie expires on session, or add param { expires: 7 } for 7 days
        
        setSplashCaptionBG();
    }
    //else kill the video
    else{
        document.getElementById("splash").remove();
    }
}


function getAverageRGB(imgEl) {
    var blockSize = 5, // only visit every 5 pixels
        defaultRGB = {r:0,g:0,b:0}, // for non-supporting envs
        canvas = document.createElement('canvas'),
        context = canvas.getContext && canvas.getContext('2d'),
        data, width, height,
        i = -4,
        length,
        rgb = {r:0,g:0,b:0},
        count = 0;
    if (!context) {
        return defaultRGB;
    }
    height = canvas.height = imgEl.naturalHeight || imgEl.offsetHeight || imgEl.height;
    width = canvas.width = imgEl.naturalWidth || imgEl.offsetWidth || imgEl.width;
    context.drawImage(imgEl, 0, 0);
    try {
        data = context.getImageData(0, 0, width, height);
    } catch(e) {
        /* security error, img on diff domain */alert('x');
        return defaultRGB;
    }
    length = data.data.length;
    while ( (i += blockSize * 4) < length ) {
        ++count;
        rgb.r += data.data[i];
        rgb.g += data.data[i+1];
        rgb.b += data.data[i+2];
    }
    // ~~ used to floor values
    rgb.r = ~~(rgb.r/count);
    rgb.g = ~~(rgb.g/count);
    rgb.b = ~~(rgb.b/count);
    return rgb;
}

function setSplashCaptionBG(){
    var imgEl = document.getElementById("splash-image");
    if(imgEl.complete && imgEl.naturalHeight !== 0){
        var captionBgColor = getAverageRGB();
        console.log('getAverageRGB found: ' + captionBgColor.r + ',' + captionBgColor.g + ',' + captionBgColor.b);
        document.getElementById("splash-caption").style.backgroundColor = "rgba(" + captionBgColor.r + "," + captionBgColor.g + "," + captionBgColor.b + ", 0.85)";
    }
    else{
        setTimeout(function(){ 
            console.log('trying again: setSplashCaptionBG()');
            setSplashCaptionBG();
        },333);
    }
}



function startPuzzle(){
    var delay = 0;
    if(typeof puzzlePieces !== 'undefined'){
        puzzlePieces = shuffle(puzzlePieces);
        for(var i=0; i<puzzlePieces.length; i++){
            var isLast = (i == (puzzlePieces.length-1));
            var div = document.createElement("DIV");
            var img = document.createElement("IMG");
            img.src = '/assets/images/splash/puzzle/'+puzzlePieces[i][0];
            img.alt = ''+puzzlePieces[i][0];
            if(puzzlePieces[i][1]=="top"){
                div.style.top = puzzlePieces[i][2] + "%";
            }
            if(puzzlePieces[i][1]=="bottom"){
                div.style.bottom = puzzlePieces[i][2] + "%";
            }
            if(puzzlePieces[i][3]=="left"){
                div.style.left = puzzlePieces[i][4] + "%";
            }
            if(puzzlePieces[i][3]=="right"){
                div.style.right = puzzlePieces[i][4] + "%";
            }
            div.appendChild(img);
            delayPuzzlePiece(div, delay, isLast);
            // delay = delay + (Math.random() * (400 - 100) + 100); //introduce variation, .2 to .6 seconds bewteen pieces
            delay = delay + (Math.random() * 100); //introduce variation, add between .01 and .1 seconds bewteen pieces
        }
    }
}

function delayPuzzlePiece(div, delay, isLast){
    //console.log('delayPuzzlePiece("' + div + '", "' + delay + '", "' + isLast + '")');
    setTimeout(function(){
        document.getElementById("overlay").appendChild(div);
        div.classList.add('animate__animated', 'animate__fadeIn');
        if(isLast){
            showWhiteThenFade();
            // setTimeout(function(){ showWhiteThenFade(); }, 200); //todo undo comment
        }
    }, delay);
}

function showWhiteThenFade(){
    document.getElementById("main").style.display = 'block';
    document.getElementById("white-fade").style.display = 'block';
    document.getElementById("white-fade").classList.add('animate__animated', 'animate__fadeIn');
    setTimeout(function(){
        document.getElementById("splash").classList.add('animate__animated', 'animate__fadeOut');
    }, 1500);
    setTimeout(function(){
        document.getElementById("splash").remove(); //so you can click on things again
    }, 2000);
}

var shuffle = function (array) {
	var currentIndex = array.length;
	var temporaryValue, randomIndex;
	// While there remain elements to shuffle...
	while (0 !== currentIndex) {
		// Pick a remaining element...
		randomIndex = Math.floor(Math.random() * currentIndex);
		currentIndex -= 1;
		// And swap it with the current element.
		temporaryValue = array[currentIndex];
		array[currentIndex] = array[randomIndex];
		array[randomIndex] = temporaryValue;
	}
	return array;
};


var puzzlePieces = [
    ['Puzzle_1.svg','top',0,'right',0],
    ['Puzzle_2.svg','bottom',10,'right',0],
    ['Puzzle_3.svg','bottom',0,'left',50],
    ['Puzzle_4.svg','top',0,'left',45],
    ['Puzzle_5.svg','top',35,'left',45],
    ['Puzzle_6.svg','top',50,'left',28],
    ['Puzzle_7.svg','top',10,'left',30],
    ['Puzzle_8.svg','top',0,'left',0],
    ['Puzzle_9.svg','bottom',0,'left',0],
    ['Puzzle_10.svg','bottom',0,'left',18],
    ['Puzzle_11.svg','top',15,'right',0],
    ['Puzzle_12.svg','bottom',0,'right',10],
    ['Puzzle_13.svg','top',0,'left',20],
    ['Puzzle_14.svg','bottom',0,'left',13],
    ['Puzzle_15.svg','top',40,'right',35],
    ['Puzzle_16.svg','bottom',0,'left',32],
    ['Puzzle_17.svg','bottom',0,'left',10],
    ['Puzzle_18.svg','top',0,'left',0],
    ['Puzzle_19.svg','top',10,'right',28],
    ['Puzzle_20.svg','top',0,'right',23],
    ['Puzzle_21.svg','top',0,'left',5],
    ['Puzzle_22.svg','bottom',0,'right',0],
    ['Puzzle_23.svg','bottom',0,'right',20],
    ['Puzzle_24.svg','bottom',0,'right',60]
];
document.addEventListener("DOMContentLoaded", () => { 
    splashInit();
});